import React from 'react';
import { Link } from 'react-router-dom';

export default function CustomLocationCard({ t }) {
  return (
    <div className="relative group h-72 w-full overflow-hidden rounded-3xl m-0 p-0">
      <img
        src="/images/restaurant4.jpg"
        alt={t.destinations.customLocation}
        className="w-full h-full object-cover group-hover:scale-105 hover:brightness-125 transition-transform duration-700"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-[rgba(24,28,36,0.48)] group-hover:bg-[rgba(24,28,36,0.22)] transition-colors duration-300" />
      <div className="absolute bottom-0 left-0 right-0 text-white z-10 flex flex-col items-start m-0 px-6 pb-6 pt-0">
        <h3 className="text-xl font-playfair mb-1 drop-shadow-[0_2px_12px_rgba(24,28,36,0.9)] text-[#e3c27b] font-semibold">{t.destinations.customLocation}</h3>
        <p className="text-base mb-2 font-light drop-shadow-[0_1px_8px_rgba(24,28,36,0.8)]">{t.destinations.customLocationDesc}</p>
        <Link
          to="/contact"
          className="inline-block border border-[#bfa76a] text-[#bfa76a] bg-transparent py-2 px-4 rounded-full text-sm font-medium hover:bg-[#bfa76a] hover:text-[#181c24] hover:border-[#bfa76a] transition-all duration-300 mt-2"
        >
          {t.contact.title}
        </Link>
      </div>
    </div>
  );
} 